(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["canvas-cart-return-language"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('canvas-cart-return-language');
    if (!configElement || !document.referrer || window.location.pathname.replace(/\/$/, '') !== '/cart') return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin !== window.location.origin) return;
      const match = previous.pathname.match(/^\/checkouts\/[^/]+\/[^/]+\/([a-z]{2,3}(?:-[a-z]{2,4}){0,2})(?:\/|$)/i);
      if (!match) return;
      const config = JSON.parse(configElement.textContent);
      const checkoutLocale = match[1].toLowerCase();
      const language = config.languages.find(item => item.code.toLowerCase() === checkoutLocale)
        || config.languages.find(item => item.code.toLowerCase() === checkoutLocale.split('-')[0]);
      if (!language || language.code.toLowerCase() === config.current.toLowerCase()) return;
      const root = new URL(language.root, window.location.origin);
      if (root.origin !== window.location.origin) return;
      const destination = new URL(window.location.href);
      destination.pathname = root.pathname.replace(/\/$/, '') + '/cart';
      if (destination.pathname !== window.location.pathname) window.location.replace(destination.href);
    } catch {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-close-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    if (root.hasAttribute('data-cb-input-mode')) return;
    root.dataset.cbInputMode = 'pointer';
    document.addEventListener('pointerdown', () => {
      root.dataset.cbInputMode = 'pointer';
    }, { capture: true, passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        root.dataset.cbInputMode = 'keyboard';
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["market-selector-dialog"] && !Shopify.designMode) return;
  try {
    class CbMarketSelector extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cb-market-open]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.returnFocus = trigger;
        const drawer = trigger.closest('burger-drawer');
        if (drawer) {
          drawer.close();
          this.returnFocus = document.querySelector('a#burger-icon-bubble');
        }
        this.form.reset();
        requestAnimationFrame(() => {
          document.documentElement.classList.add('cb-market-open');
          this.dialog.showModal();
        });
      }, { ...options, capture: true });
      this.querySelector('[data-cb-market-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cb-market-open');
        this.returnFocus?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = this.dialog.querySelectorAll('button:not([disabled]), input[type="radio"]:checked');
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.form.addEventListener('submit', () => {
        const selected = this.form.querySelector('input[name="country_code"]:checked');
        const language = this.form.elements.language_code;
        language.value = selected?.dataset.languageCode?.trim() || '';
        language.disabled = !language.value;
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('cb-market-open');
    }
  }
  if (!customElements.get('cb-market-selector')) customElements.define('cb-market-selector', CbMarketSelector);
  } catch(e) { console.error(e); }
})();

})();
